document.addEventListener('DOMContentLoaded', () => {
  const selectors = ['#confirm-order-btn', '.confirm-order-btn', '[data-confirm-order]'];

  const resolveTargetUrl = (status = 'success', explicitUrl) => {
    const enc = encodeURIComponent(status);
    const addStatusParam = (url) => {
      try {
        const hasQuery = url.includes('?');
        const sep = hasQuery ? '&' : '?';
        return `${url}${sep}status=${enc}`;
      } catch (_) {
        return url;
      }
    };

    if (explicitUrl) return addStatusParam(explicitUrl);

    const host = window.location.hostname;
    const port = window.location.port;
    const path = window.location.pathname || '';

    // Shopify CLI 开发代理（127.0.0.1:9292 或 localhost:9292）
    const isShopifyDevProxy = (host === '127.0.0.1' || host === 'localhost') && port === '9292';
    if (isShopifyDevProxy) {
      return `${window.location.protocol}//${host}:${port}/pages/order-confirmation?status=${enc}`;
    }

    // Python 本地预览（localhost:8000/preview/...）
    const isLocalPreview = (host === 'localhost' && port === '8000') && path.startsWith('/preview/');
    if (isLocalPreview) {
      return `/preview/order-confirmation-preview.html?status=${enc}`;
    }

    // 线上站点：使用 theme 注入的 shopUrl
    if (typeof window.shopUrl === 'string' && window.shopUrl.length > 0) {
      return `${window.shopUrl}/pages/order-confirmation?status=${enc}`;
    }

    // 回退
    return `/pages/order-confirmation?status=${enc}`;
  };

  const getMatchEl = (target) => {
    if (!target) return null;
    if (selectors.some((s) => target.matches?.(s))) return target;
    return target.closest?.(selectors.join(',')) || null;
  };

  // 动态内容场景采用事件委托，确保后续加载的按钮也能被拦截
  document.body.addEventListener(
    'click',
    (evt) => {
      const el = getMatchEl(evt.target);
      if (!el) return;
      const statusAttr = el.getAttribute('data-status') || 'success';
      const explicitUrl = el.getAttribute('data-url') || el.getAttribute('data-redirect');
      evt.preventDefault();
      evt.stopPropagation();
      window.location.assign(resolveTargetUrl(statusAttr, explicitUrl));
    },
    { capture: true }
  );
});